import { useNavigate } from 'react-router-dom';
import { ArrowRight, MessageSquare } from 'lucide-react';
import { RippleButton } from '@/components/animations';

export function FinalCTASection() {
  const navigate = useNavigate();

  return (
    <section id="cta" className="py-20 md:py-28 border-t border-border bg-muted/30">
      <div className="container">
        <div className="max-w-2xl mx-auto text-center space-y-8">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 text-primary text-sm font-medium">
            <MessageSquare className="w-4 h-4" />
            Comece agora
          </div>
          <h2 className="text-3xl md:text-4xl font-bold">
            Primeiro ajudamos a decidir.
            <br />
            <span className="text-primary">Depois oferecemos continuidade.</span>
          </h2>
          <p className="text-lg text-muted-foreground">
            Crie uma conta gratuita para analisar o seu caso com apoio técnico
            independente.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <RippleButton
              size="lg"
              onClick={() => navigate('/members/auth')}
              className="gap-2 text-base px-8 py-6"
            >
              Criar conta gratuita e analisar o meu caso
              <ArrowRight className="w-5 h-5" />
            </RippleButton>
          </div>
          <p className="text-sm text-muted-foreground">
            Para garantir rigor técnico, rastreabilidade e histórico de decisão.
          </p>
        </div>
      </div>
    </section>
  );
}
